
function resolveCartItemQuantityStep(item) {
  return 1;
}

function filterCustomerProperties(propertyArray) {
  if (!Array.isArray(propertyArray)) return [];

  return propertyArray.filter(function(property) {
    if (!property || !property.name || property.value == null || property.value === '') {
      return false;
    }

    return property.name.charAt(0) !== '_';
  });
}

if (window.rivets && window.rivets.formatters) {
  window.rivets.formatters.quantity_minus_step = function(item) {
    var step = resolveCartItemQuantityStep(item);
    var quantity = parseInt(item && item.quantity, 10) || 0;

    return Math.max(0, quantity - step);
  };

  window.rivets.formatters.quantity_plus_step = function(item) {
    var step = resolveCartItemQuantityStep(item);
    var quantity = parseInt(item && item.quantity, 10) || 0;

    return quantity + step;
  };

  window.rivets.formatters.customer_properties = function(propertyArray) {
    return filterCustomerProperties(propertyArray);
  };
}

function getAzOnlyProductStatusMap() {
  if (!window._azOnlyProductStatus || typeof window._azOnlyProductStatus !== 'object') {
    window._azOnlyProductStatus = {};
  }

  return window._azOnlyProductStatus;
}

function getPhoenixOnlyProductStatusMap() {
  if (!window._phoenixOnlyProductStatus || typeof window._phoenixOnlyProductStatus !== 'object') {
    window._phoenixOnlyProductStatus = {};
  }

  return window._phoenixOnlyProductStatus;
}

function getWesternOnlyProductStatusMap() {
  if (!window._westernOnlyProductStatus || typeof window._westernOnlyProductStatus !== 'object') {
    window._westernOnlyProductStatus = {};
  }

  return window._westernOnlyProductStatus;
}

// Only an exact, positively confirmed merch tag exempts a line from the ZIP gate.
function getMerchProductStatusMap() {
  if (!window._merchProductStatus || typeof window._merchProductStatus !== 'object') {
    window._merchProductStatus = {};
  }
  return window._merchProductStatus;
}

function isRenderedCartMerchOnly() {
  if (window._merchCartNeedsRefresh) return false;
  var rows = Array.from(document.querySelectorAll('#cart-items .bh-cart-item'));
  var statuses = getMerchProductStatusMap();
  return rows.length > 0 && rows.every(function(row) {
    var id = row.dataset.productId || '';
    return /^[1-9][0-9]*$/.test(id) && statuses[id] === true;
  });
}

function refreshCheckoutPostalState() {
  var blocked = window._checkoutPostalBlocked !== false && !isRenderedCartMerchOnly();
  document.querySelectorAll('.bh-checkout-button').forEach(function(button) {
    button.dataset.postalBlocked = blocked ? 'true' : 'false';
    syncCheckoutButtonState(button);
  });
}

function getAzOnlyLookupMap() {
  if (!window._azOnlyProductLookups || typeof window._azOnlyProductLookups !== 'object') {
    window._azOnlyProductLookups = {};
  }

  return window._azOnlyProductLookups;
}

function getPackSizeMap() {
  if (!window._packSizeByProductId || typeof window._packSizeByProductId !== 'object') {
    window._packSizeByProductId = {};
  }

  return window._packSizeByProductId;
}

function packSizeFromTags(tags) {
  if (!Array.isArray(tags)) return 1;

  for (var index = 0; index < tags.length; index += 1) {
    var match = String(tags[index]).match(/^pack-size\s*:\s*(\d+)$/i);
    if (match && parseInt(match[1], 10) > 1) return parseInt(match[1], 10);
  }

  return 1;
}

function formatPackEquivalence(quantity, packSize) {
  if (!packSize || packSize <= 1) return '';

  var template = window._packEquivalenceTemplate || '__quantity__ × __pack_size__-pack (__burrito_count__ burritos)';
  return template
    .replace('__quantity__', String(quantity))
    .replace('__pack_size__', String(packSize))
    .replace('__burrito_count__', String(quantity * packSize));
}

function syncCheckoutButtonState(button) {
  if (!button) return;

  var postalBlocked = button.dataset.postalBlocked === 'true';
  var azOnlyBlocked = button.dataset.azOnlyBlocked === 'true';
  var isBlocked = postalBlocked || azOnlyBlocked;

  button.classList.toggle('disabled', isBlocked);
  button.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');

  if (isBlocked) {
    button.setAttribute('tabindex', '-1');
  } else {
    button.removeAttribute('tabindex');
  }
}

function setCheckoutPostalBlocked(isBlocked) {
  // Retain the burrito ZIP decision so adding a burrito restores its gate.
  window._checkoutPostalBlocked = Boolean(isBlocked);
  refreshCheckoutPostalState();
}

function setCheckoutAzOnlyBlocked(isBlocked) {
  var checkoutBtn = document.querySelector('#cart-checkout .bh-checkout-button');
  if (!checkoutBtn) return;

  checkoutBtn.dataset.azOnlyBlocked = isBlocked ? 'true' : 'false';
  syncCheckoutButtonState(checkoutBtn);
}

function isNonArizonaShipping(zipType, savedZip) {
  if (zipType !== 'shipping' || !savedZip) return false;

  var zipPrefix = savedZip.substring(0, 2);
  return zipPrefix !== '85' && zipPrefix !== '86';
}

function getRenderedCartProductIds() {
  var productIds = [];

  document.querySelectorAll('.bh-cart-item[data-product-id]').forEach(function(item) {
    var productId = parseInt(item.dataset.productId, 10);

    if (!isNaN(productId)) {
      productIds.push(productId);
    }
  });

  return productIds;
}

// Shared cart evaluation: is any rendered cart item restricted per statusById?
// Unknown status (still resolving, or fetch failed) blocks as a safe default.
function evaluateCartRestriction(statusById, restrictedReason) {
  var cartProductIds = getRenderedCartProductIds();
  var hasUnknown = false;
  var hasRestricted = cartProductIds.some(function(productId) {
    var status = statusById[String(productId)];

    if (status === true) return true;
    if (status !== false) hasUnknown = true;
    return false;
  });

  if (hasRestricted) return { blocked: true, reason: restrictedReason };
  if (hasUnknown) return { blocked: true, reason: 'unknown' };

  return { blocked: false, reason: null };
}

function getAzOnlyRestrictionState() {
  var zipType = localStorage.getItem('bhZipType');
  var savedZip = localStorage.getItem('bhZipCode');

  if (!isNonArizonaShipping(zipType, savedZip)) {
    return { blocked: false, reason: null };
  }

  return evaluateCartRestriction(getAzOnlyProductStatusMap(), 'az-only');
}

function getPhoenixOnlyRestrictionState() {
  var zipType = localStorage.getItem('bhZipType');

  // Phoenix-only products can't ship anywhere, so ANY shipping-tier zip
  // (including AZ ones) is blocked. Delivery-tier zips can buy them.
  if (zipType !== 'shipping') {
    return { blocked: false, reason: null };
  }

  return evaluateCartRestriction(getPhoenixOnlyProductStatusMap(), 'phoenix-only');
}

function getWesternOnlyRestrictionState() {
  var zipType = localStorage.getItem('bhZipType');

  // Western-only products ship from Azoria only. Live east coast (Grip) zips
  // carry the arrival-promise fields; upcoming east zips are already blocked
  // by the global postal gate, so shipping tier is the only one to check.
  if (zipType !== 'shipping' || !localStorage.getItem('bhEcMinDelivery')) {
    return { blocked: false, reason: null };
  }

  return evaluateCartRestriction(getWesternOnlyProductStatusMap(), 'western-only');
}

function openSideCart() {
  const sideCart = document.getElementById('bh-side-cart');
  const overlay = document.getElementById('bh-side-cart-overlay');
  
  if (sideCart && overlay) {
    sideCart.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (!window._isRefreshingSideCart) {
      checkAzOnlyRestriction();
    }
  }
}

function closeSideCart() {
  const sideCart = document.getElementById('bh-side-cart');
  const overlay = document.getElementById('bh-side-cart-overlay');
  
  if (sideCart && overlay) {
    sideCart.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

/* =====================================================
   Cart mutation resilience (2026-08 cart audit):
   - responses parse by content type, so an HTML challenge
     or proxy page fails cleanly instead of throwing inside
     response.json();
   - every failure shows a shopper-visible message and
     resyncs the drawer — line-item keys re-hash on discount
     transitions, so a stale key otherwise 400s silently and
     the resync is what restores working controls;
   - pageshow heals the bfcache-restored drawer after
     checkout -> Back, which is the flow that left every
     control silently dead.
   ===================================================== */

var BH_CART_UPDATE_ERROR = "Couldn't update your cart. Please try again.";
var BH_CART_REDRAW_ERROR = 'Your cart may be out of date. Refresh the page.';

function bhCartRoute(routeName, fallbackBase) {
  var base = (window.routes && window.routes[routeName]) || fallbackBase;
  return base + '.js';
}

function showCartMessage(message) {
  var messageElement = document.getElementById('bh-cart-message');
  if (!messageElement) return;

  messageElement.textContent = message;
  messageElement.classList.remove('hidden');
}

function clearCartMessage() {
  var messageElement = document.getElementById('bh-cart-message');
  if (!messageElement) return;

  messageElement.textContent = '';
  messageElement.classList.add('hidden');
}

function parseCartJsonResponse(response) {
  var contentType = ((response.headers && response.headers.get('Content-Type')) || '').toLowerCase();

  // Shopify's cart endpoints answer with text/javascript, so only an HTML
  // content type (challenge/interstitial page) short-circuits; anything
  // else must still survive the JSON parse below.
  if (contentType.indexOf('text/html') !== -1) {
    var typeError = new Error('Unexpected cart response (status ' + response.status + ')');
    typeError.status = response.status;
    return Promise.reject(typeError);
  }

  return response.json()
    .catch(function() {
      var parseError = new Error('Unexpected cart response (status ' + response.status + ')');
      parseError.status = response.status;
      throw parseError;
    })
    .then(function(payload) {
      if (!response.ok) {
        var error = new Error(payload.description || payload.message || 'Unable to update cart');
        error.status = response.status;
        throw error;
      }

      return payload;
    });
}

function setCartControlsDisabled(disabled) {
  var cartItems = document.getElementById('cart-items');
  if (!cartItems) return;

  cartItems.querySelectorAll('[data-cart-quantity]').forEach(function(control) {
    control.disabled = disabled;
  });
}

function refreshSideCart() {
  var generation = (window._sideCartRefreshGeneration || 0) + 1;
  window._sideCartRefreshGeneration = generation;
  window._isRefreshingSideCart = true;
  // Do not carry an old merch exemption through an in-flight or failed redraw.
  window._merchCartNeedsRefresh = true;
  refreshCheckoutPostalState();
  updateEcShippingSummary();

  // no-store: a resync exists to observe the live cart, so it must never
  // be satisfied from the HTTP cache (history navigations restore pages
  // whose cached /cart.js predates the checkout's mutations).
  return fetch(bhCartRoute('cart_url', '/cart'), { cache: 'no-store' })
    .then(parseCartJsonResponse)
    .then(cart => {
      // A late response must not redraw a cart newer requests are reconciling.
      if (generation !== window._sideCartRefreshGeneration) return;
      console.log('Refreshed cart:', cart);
      clearCartMessage();

      // Update cart counter
      const cartCounter = document.getElementById('counter');
      if (cartCounter) {
        cartCounter.setAttribute('data-count', cart.item_count);
      }
      
      // Update cart items container
      const cartItemsContainer = document.getElementById('cart-items');
      
      if (cart.item_count === 0) {
        cartItemsContainer.classList.add('cart-empty');
        cartItemsContainer.innerHTML = `
          <div>
            <h3>Your cart is empty</h3>
            <a href="/collections/all" class="bh-cta">Shop Burritos</a>
          </div>
        `;
      } else {
        cartItemsContainer.classList.remove('cart-empty');
        
        // Rebuild all cart items HTML
        cartItemsContainer.innerHTML = cart.items.map(item => {
          const imageUrl = item.featured_image ? item.featured_image.url : '';
          const productTitle = item.product_title || '';
          const quantityStep = resolveCartItemQuantityStep(item);
          const packSize = getPackSizeMap()[String(item.product_id)] || 1;
          const packEquivalence = formatPackEquivalence(item.quantity, packSize);
          const decreaseQuantity = Math.max(0, item.quantity - quantityStep);
          const increaseQuantity = item.quantity + quantityStep;

          return `
            <div class="bh-cart-item" data-line-item-key="${item.key}" data-product-id="${item.product_id}" data-variant-title="${(item.variant_title || '').replace(/"/g, '&quot;')}">
              <img class="cart-item-thumbnail" src="${imageUrl}" alt="${productTitle}" loading="lazy">
              
              <div class="cart-item-content">
                <a href="${item.url}" class="product-title">${productTitle}</a>
                ${packEquivalence ? `<span class="pack-equivalence">${packEquivalence}</span>` : ''}
                ${window.subscriptionLabel ? `<a style="text-decoration: underline;" href="${item.url}">${window.subscriptionLabel}</a>` : ''}
                <div class="product-quantity-wrapper">
                  <div class="product-quantity">
                    <button type="button" class="bh-button" data-cart-quantity="${decreaseQuantity}">-</button>
                    <span class="quantity-display">${item.quantity}</span>
                    <button type="button" class="bh-button" data-cart-quantity="${increaseQuantity}">+</button>
                  </div>
                  <button type="button" class="trash-icon" data-cart-quantity="0" aria-label="${window._cartRemoveLabel || 'Remove'}">
                    ${window.trashIconSVG || ''}
                  </button>
                </div>
              </div>
              
              <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
            </div>
          `;
        }).join('');
      }
      
      // Update subtotal
      const subtotalElement = document.querySelector('#cart-checkout div span:last-child');
      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price);
      }

      // T9: keep the east coast estimated total in step with the cart
      window._cartTotalPrice = cart.total_price;
      window._cartTotalDiscount = cart.total_discount;
      updateEcShippingSummary();

      // Update discount eligibility flag based on cart contents
      window._cartHasDiscountEligible = cart.items.some(
        item => item.product_type === 'Burritos'
      );

      // Load product tags for az-only enforcement and pack-size annotations.
      return updateCartProductMetadata(cart).then(function() {
        if (generation !== window._sideCartRefreshGeneration) return;
        refreshPackEquivalenceLabels(cart);
        checkAzOnlyRestriction();
        window._merchCartNeedsRefresh = false;
        refreshCheckoutPostalState();
        // Re-render the drawer's zip message too: its copy depends on cart
        // composition (merch-aware blocked message). Falls back for tests
        // that load this file without the postal checker.
        if (typeof updatePostalChecker === 'function') {
          updatePostalChecker();
        } else {
          updateEcShippingSummary();
        }
        return cart;
      });
    })
    .catch(error => {
      if (generation !== window._sideCartRefreshGeneration) return;
      console.error('Error refreshing cart:', error);
      showCartMessage(BH_CART_REDRAW_ERROR);
    })
    .then(function(result) {
      if (generation === window._sideCartRefreshGeneration) window._isRefreshingSideCart = false;
      return result;
    });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* =====================================================
   T9: east coast flat-shipping summary (comms §3 rule 9)

   The flat line is only true for east coast carts (west coast
   rates vary by service), so it renders only while the saved
   zip carries a live east coast promise: bhEcMinDelivery
   exists exactly when zipcheck returned the Grip fields, and
   the postal checker clears it on any zip change or dial-down.
   No promise, no saved zip, or dial below 7 -> drawer unchanged.
   ===================================================== */

var BH_EC_FLAT_SHIPPING_CENTS = 1499;

// Resolved cart composition, shared with the postal checker so the drawer's
// zip message can go merch-aware without duplicating the status plumbing.
function bhCartMerchMix() {
  var rows = Array.from(document.querySelectorAll('#cart-items .bh-cart-item'));
  var statuses = getMerchProductStatusMap();
  var resolved = !window._merchCartNeedsRefresh && rows.length > 0 && rows.every(function(row) {
    var id = row.dataset.productId || '';
    return /^[1-9][0-9]*$/.test(id) && typeof statuses[id] === 'boolean';
  });
  return {
    rows: rows,
    statuses: statuses,
    resolved: resolved,
    merchOnly: resolved && isRenderedCartMerchOnly(),
    hasMerch: resolved && rows.some(function(row) { return statuses[row.dataset.productId] === true; })
  };
}

// Shared copy from both approved launch-mode drafts. No mixed-mode promise here.
function updateMerchCartPresentation() {
  var mix = bhCartMerchMix();
  var rows = mix.rows;
  var statuses = mix.statuses;
  var resolved = mix.resolved;
  var merchOnly = mix.merchOnly;
  var hasMerch = mix.hasMerch;
  rows.forEach(function(row) {
    var note = row.querySelector('.bh-merch-line-shipping');
    var sizeLine = row.querySelector('.bh-merch-line-size');
    var title = row.querySelector('.product-title');
    var isMerchRow = resolved && statuses[row.dataset.productId] === true;
    // "Size: M" above the shipping note; one-size items (the cap) skip it.
    var variantTitle = (row.dataset.variantTitle || '').trim();
    var showSize = isMerchRow && variantTitle && variantTitle !== 'Default Title' && variantTitle !== 'One Size';
    if (!showSize && sizeLine) {
      sizeLine.remove();
      sizeLine = null;
    }
    if (showSize) {
      if (!sizeLine && title) {
        sizeLine = document.createElement('span');
        sizeLine.className = 'bh-merch-line-size';
        title.insertAdjacentElement('afterend', sizeLine);
      }
      if (sizeLine) sizeLine.textContent = 'Size: ' + variantTitle;
    }
    var show = isMerchRow && window._cartMerchLineShipping;
    if (!show) {
      if (note) note.remove();
      return;
    }
    if (!note && title) {
      note = document.createElement('span');
      note.className = 'bh-merch-line-shipping';
      var anchor = sizeLine || title;
      anchor.insertAdjacentElement('afterend', note);
    }
    if (note) {
      note.textContent = merchOnly
        ? window._cartMerchLineShipping
        : (window._cartMerchLineShippingMixed || window._cartMerchLineShipping);
    }
  });
  var cartNote = document.getElementById('bh-merch-cart-shipping');
  if (cartNote) {
    cartNote.classList.toggle('hidden', !merchOnly);
    if (window._cartMerchOnlyShipping) cartNote.textContent = window._cartMerchOnlyShipping;
  }
  // Merch-only carts skip burrito geography entirely: hide the zip checker
  // (checkout is already exempted via refreshCheckoutPostalState).
  var zipCheck = document.getElementById('cart-zip-check');
  if (zipCheck) zipCheck.classList.toggle('hidden', merchOnly);
  // The postal checker updates before this function. Keep its ZIP message intact,
  // but never carry the local burrito discount claim into an all-merch cart.
  var discountBar = document.getElementById('cart-discount-bar');
  var showLocalDiscount = resolved && !merchOnly && localStorage.getItem('bhZipType') === 'delivery' && window._cartHasDiscountEligible;
  if (discountBar) {
    discountBar.classList.toggle('hidden', !showLocalDiscount);
    var burritoCopy = discountBar.querySelector('[data-discount-burrito-copy]');
    var merchCopy = discountBar.querySelector('[data-discount-merch-copy]');
    if (burritoCopy) burritoCopy.classList.toggle('hidden', hasMerch);
    if (merchCopy) merchCopy.classList.toggle('hidden', !hasMerch);
  }
  return { resolved: resolved, merchOnly: merchOnly };
}

function updateEcShippingSummary() {
  var cartState = updateMerchCartPresentation();
  var block = document.getElementById('bh-ec-cart-shipping');
  if (!block) return;

  var totalCents = Number(window._cartTotalPrice) || 0;
  var isEcShipping =
    localStorage.getItem('bhZipType') === 'shipping' &&
    !!localStorage.getItem('bhEcMinDelivery');

  if (!cartState.resolved || cartState.merchOnly || !isEcShipping || totalCents <= 0) {
    block.classList.add('hidden');
    return;
  }

  var totalEl = block.querySelector('[data-bh-ec-total]');
  if (totalEl) totalEl.textContent = formatMoney(totalCents + BH_EC_FLAT_SHIPPING_CENTS);
  block.classList.remove('hidden');
}

// Module-level: register cart AJAX handlers once
let _addToCartButton = null;

$(document).ajaxSuccess(function(event, jqxhr, settings) {
  if (settings.url === '/cart/add.js' || settings.url === '/cart/change.js') {
    $(document).one('cart.requestComplete', function(event, cart) {
      console.log(cart);
      refreshSideCart();
      openSideCart();
      if (_addToCartButton) {
        _addToCartButton.classList.remove('loading');
        _addToCartButton = null;
      }
    });
  }
});

$(document).ajaxError(function(event, jqxhr, settings) {
  if (settings.url === '/cart/add.js' || settings.url === '/cart/change.js') {
    if (_addToCartButton) {
      _addToCartButton.classList.remove('loading');
      _addToCartButton = null;
    }
    const errorDescription = jqxhr.responseJSON && jqxhr.responseJSON.description;
    if (errorDescription) {
      alert(errorDescription);
      console.log(errorDescription);
    }
  }
});

function onProductAdd(obj) {
  _addToCartButton = obj;
  obj.classList.add('loading');
}

document.addEventListener('click', function(event) {
  if (!event.target || typeof event.target.closest !== 'function') return;

  var button = event.target.closest('[data-cart-quantity]');
  var cartItems = document.getElementById('cart-items');

  if (!button || !cartItems || !cartItems.contains(button)) return;

  event.preventDefault();

  var itemElement = button.closest('.bh-cart-item');
  var lineItemKey = itemElement && itemElement.dataset.lineItemKey;
  var newQuantity = parseInt(button.dataset.cartQuantity, 10);

  if (!lineItemKey || isNaN(newQuantity) || newQuantity < 0 || button.disabled) return;

  updateCartQuantity(lineItemKey, newQuantity, button);
});

function updateCartQuantity(lineItemKey, newQuantity, triggerButton) {
  if (newQuantity < 0) return;

  const itemElement = document.querySelector(`[data-line-item-key="${CSS.escape(lineItemKey)}"]`);
  if (!itemElement) return;

  const itemPriceElement = itemElement.querySelector('.cart-item-price');
  const originalPrice = itemPriceElement ? itemPriceElement.textContent : '';

  // All quantity controls lock together: a second mutation against
  // pre-redraw cart state can target a line the first one re-keyed.
  setCartControlsDisabled(true);
  if (itemPriceElement) {
    itemPriceElement.classList.add('bh-loader-black');
    itemPriceElement.textContent = '';
  }

  return fetch(bhCartRoute('cart_change_url', '/cart/change'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: newQuantity
    })
  })
  .then(parseCartJsonResponse)
  .then(() => {
    return refreshSideCart();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    if (itemPriceElement && itemPriceElement.isConnected) {
      itemPriceElement.textContent = originalPrice;
    }

    // Resync before messaging: the redraw replaces stale line-item keys,
    // so the shopper's retry targets a live line. If the resync itself
    // fails, refreshSideCart already showed the stronger redraw message.
    return refreshSideCart().then(function(cart) {
      if (cart) showCartMessage(BH_CART_UPDATE_ERROR);
    });
  })
  .finally(() => {
    setCartControlsDisabled(false);
    if (itemPriceElement && itemPriceElement.isConnected) {
      itemPriceElement.classList.remove('bh-loader-black');
    }
  });
}

function updateCartProductMetadata(cart) {
  var statusById = getAzOnlyProductStatusMap();
  var phoenixById = getPhoenixOnlyProductStatusMap();
  var westernById = getWesternOnlyProductStatusMap();
  var packSizeById = getPackSizeMap();
  var merchById = getMerchProductStatusMap();
  var lookupMap = getAzOnlyLookupMap();
  var seenProductIds = {};
  var fetches = [];

  cart.items.forEach(function(item) {
    var productId = String(item.product_id);

    if (seenProductIds[productId]) return;
    seenProductIds[productId] = true;

    if (statusById[productId] !== undefined && phoenixById[productId] !== undefined && westernById[productId] !== undefined && packSizeById[productId] !== undefined && typeof merchById[productId] === 'boolean') return;

    if (!item.handle) {
      merchById[productId] = 'unknown';
      statusById[productId] = 'unknown';
      phoenixById[productId] = 'unknown';
      westernById[productId] = 'unknown';
      packSizeById[productId] = 1;
      return;
    }

    if (!lookupMap[productId]) {
      lookupMap[productId] = fetch('/products/' + item.handle + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to load product metadata');
          }

          return response.json();
        })
        .then(function(product) {
          merchById[productId] = Array.isArray(product.tags) ? product.tags.indexOf('merch') !== -1 : 'unknown';
          statusById[productId] = Boolean(product.tags && product.tags.indexOf('az-only') !== -1);
          phoenixById[productId] = Boolean(product.tags && product.tags.indexOf('phoenix-only') !== -1);
          westernById[productId] = Boolean(product.tags && product.tags.indexOf('western-only') !== -1);
          packSizeById[productId] = packSizeFromTags(product.tags);
        })
        .catch(function(error) {
          console.warn('Unable to confirm restriction tags for cart item', item.handle, error);
          merchById[productId] = 'unknown';
          statusById[productId] = 'unknown';
          phoenixById[productId] = 'unknown';
          westernById[productId] = 'unknown';
          packSizeById[productId] = 1;
        })
        .then(function() {
          delete lookupMap[productId];
        });
    }

    fetches.push(lookupMap[productId]);
  });

  return Promise.all(fetches);
}

function refreshPackEquivalenceLabels(cart) {
  var packSizeById = getPackSizeMap();

  cart.items.forEach(function(item) {
    var itemElement = document.querySelector('[data-line-item-key="' + CSS.escape(item.key) + '"]');
    if (!itemElement) return;

    var content = itemElement.querySelector('.cart-item-content');
    var title = itemElement.querySelector('.product-title');
    var existing = itemElement.querySelector('.pack-equivalence');
    var label = formatPackEquivalence(item.quantity, packSizeById[String(item.product_id)] || 1);

    if (!label) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'pack-equivalence';
      content.insertBefore(existing, title.nextSibling);
    }

    existing.textContent = label;
  });
}

// Named for its cross-file callers (bh-postal-checker.js, handleCheckout);
// now evaluates the AZ-only, Phoenix-only and Western-only cart restrictions.
// The combined result rides the existing data-az-only-blocked checkout flag.
function checkAzOnlyRestriction() {
  var azWarning = document.querySelector('.bh-az-only-cart-warning');
  var phoenixWarning = document.querySelector('.bh-phoenix-only-cart-warning');
  var westernWarning = document.querySelector('.bh-western-only-cart-warning');
  var checkoutBtn = document.querySelector('#cart-checkout .bh-checkout-button');
  if (!checkoutBtn || (!azWarning && !phoenixWarning && !westernWarning)) return;

  var azState = getAzOnlyRestrictionState();
  var phxState = getPhoenixOnlyRestrictionState();
  var westState = getWesternOnlyRestrictionState();
  var blocked = azState.blocked || phxState.blocked || westState.blocked;

  // One banner at a time: phoenix wins over western wins over az
  var showPhx = phxState.blocked;
  var showWest = westState.blocked && !showPhx;
  var showAz = azState.blocked && !showPhx && !showWest;
  if (phoenixWarning) phoenixWarning.classList.toggle('hidden', !showPhx);
  if (westernWarning) westernWarning.classList.toggle('hidden', !showWest);
  if (azWarning) azWarning.classList.toggle('hidden', !showAz);
  setCheckoutAzOnlyBlocked(blocked);

  return blocked;
}

function handleCheckout(obj, event) {
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }

  if (!obj) return false;

  checkAzOnlyRestriction();
  syncCheckoutButtonState(obj);

  if (
    obj.classList.contains('disabled') ||
    obj.dataset.postalBlocked === 'true' ||
    obj.dataset.azOnlyBlocked === 'true'
  ) {
    return false;
  }

  obj.textContent = '';
  var loader = document.createElement('span');
  loader.className = 'bh-loader';
  obj.appendChild(loader);

  // Method selection and the date/slot picker live in checkout now (BH Scheduling app);
  // the /cart detour only existed so Zapiet's cart-page widget could run.
  window.location.href = '/checkout';
}

// checkout -> Back restores the drawer with pre-checkout line-item keys
// (checkout re-keys lines when it attaches discounts), so resync before
// the shopper touches a control. Covers both restore flavors: a bfcache
// snapshot (persisted) and re-parsed HTML served from the HTTP cache on
// a history navigation (back_forward).
window.addEventListener('pageshow', function(event) {
  var navigationEntry =
    window.performance &&
    typeof performance.getEntriesByType === 'function' &&
    performance.getEntriesByType('navigation')[0];

  if (event.persisted || (navigationEntry && navigationEntry.type === 'back_forward')) {
    refreshSideCart();
  }
});
